import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

const FIELDS = [
  ["cashapp_tag", "Cash App $cashtag"],
  ["paypal_handle", "PayPal.me link or email (optional — buyers see your QR code)"],
  ["applepay_number", "Apple Pay / Apple Cash phone number"],
  ["btc_address", "Bitcoin wallet"],
  ["eth_address", "Ethereum wallet"],
  ["usdt_address", "USDT (TRC20) wallet"],
  ["discord_url", "Discord invite link"],
  ["support_email", "Support email (buyers can reply here)"],
  ["alert_email", "Your email for new-order alerts (private)"],
];

const toLocal = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};
const inputCls = "mt-1.5 h-11 w-full border border-white/15 bg-black/40 px-3 font-mono text-sm normal-case text-white focus:border-[#a259ff] focus:outline-none";

export const SettingsTab = () => {
  const [s, setS] = useState(null);

  useEffect(() => {
    api.get("/admin/settings").then((r) => setS(r.data ?? {})).catch(() => setS({}));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put("/admin/settings", s);
      toast.success("Payment info saved");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  if (!s) return null;
  return (
    <form onSubmit={save} className="mt-6 max-w-xl space-y-4" data-testid="admin-settings-form">
      <p className="text-sm text-slate-400">Shown to buyers on their order page when they pick crypto or Cash App.</p>
      {FIELDS.map(([k, label]) => (
        <label key={k} className="block font-mono text-[11px] uppercase tracking-widest text-slate-400">
          {label}
          <input value={s[k] ?? ""} onChange={(e) => setS((v) => ({ ...v, [k]: e.target.value }))} className="mt-1.5 h-11 w-full border border-white/15 bg-black/40 px-3 font-mono text-sm normal-case text-white focus:border-[#a259ff] focus:outline-none" data-testid={`settings-${k}-input`} />
        </label>
      ))}
      <div className="space-y-4 border-t border-white/10 pt-6" data-testid="settings-drop-section">
        <p className="font-display text-3xl uppercase text-white">Next drop countdown</p>
        <p className="text-sm text-slate-400">Shows a countdown on the homepage. The promo code stays hidden until the timer hits zero, then shows for 3 days. Clear the date to hide it.</p>
        <label className="block font-mono text-[11px] uppercase tracking-widest text-slate-400">Drop title
          <input value={s.drop_title ?? ""} onChange={(e) => setS((v) => ({ ...v, drop_title: e.target.value }))} placeholder="Friday night drop" className={inputCls} data-testid="settings-drop_title-input" />
        </label>
        <label className="block font-mono text-[11px] uppercase tracking-widest text-slate-400">Drop date & time (your local time)
          <input type="datetime-local" value={toLocal(s.drop_at)} onChange={(e) => setS((v) => ({ ...v, drop_at: e.target.value ? new Date(e.target.value).toISOString() : null }))} className={`${inputCls} [color-scheme:dark]`} data-testid="settings-drop_at-input" />
        </label>
        <label className="block font-mono text-[11px] uppercase tracking-widest text-slate-400">Promo code to reveal (create it in Promo codes)
          <input value={s.drop_code ?? ""} onChange={(e) => setS((v) => ({ ...v, drop_code: e.target.value.toUpperCase() }))} placeholder="DROP20" className={`${inputCls} uppercase`} data-testid="settings-drop_code-input" />
        </label>
      </div>
      <button className="h-12 bg-[#a259ff] px-8 font-mono text-xs font-bold uppercase tracking-widest text-black" data-testid="settings-save-button">Save</button>
    </form>
  );
};
